import React, { useEffect, useState } from "react";
import PostApiCall from "../Api/Api";
import moment from "moment";
import Notiflix, { Report } from "notiflix";
import { ToastContainer, toast } from "react-toastify";
import {
  CandidateAlreadyRegitered,
  SomethingWrong,
} from "../Helper/ErrorMessages";
import OtpInput from "react-otp-input";
import { delay } from "../Helper/ToastDelay";
import { useNavigate } from "react-router-dom";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import logo from "../assets/profile/verify.jpg";
import Select from "react-select";
import { Eye, EyeOff, Key, Mail, Smartphone, User, Globe } from "react-feather";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";

import { fetchData } from "../Store/Actions/LoginAction";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const BannerForm = ({ refercode }) => {

  const [EmailRegex] = useState(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  const [NumRegex] = useState(/^[6-9]\d{9}$/);
  const [OtpEntered, setOtpEntered] = useState("");

  const [ShowPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const history = useNavigate();
  const [showError, setShowError] = useState(false);

  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  const [showConfirmPassEye, setShowConfirmPassEye] = useState(false);
  const [passwordModal, setPassModal] = useState(false);
  const [user, setUser] = useState({
    Name: "",
    Email: "",
    Mobile: "",
    Pass: "",
    Confirm_Pass: "",
    RegisterType: "",
    isAccept: false,
    Source: "",
    OtherSource: "",
  });

  const onVerifyClicked = () => {
    const payload = {
      name: user.Name.toLowerCase(),
      email: user.Email.toLowerCase(),
      mobile: user.Mobile || "",
      password: user.Pass,
      usertype: "Seeker",
      updatedon: moment().format("ll"),
      addedon: moment().format("ll"),
      emailverify: "No",
      refercode: refercode || "",
      flag: false,
      source: user.Source,
      othersource: user.OtherSource
    };

    const isValid = validateForm();

    if (isValid) {
      Notiflix.Loading.standard();
      PostApiCall.postRequest(payload, "RegisterCandidate").then((resultdes) =>
        resultdes
          .json()
          .then((obj) => {
            if (resultdes.status === 200) {
              GenerateOTP(user.Email);
              setShowOTP(true);
              //   Notiflix.Loading.remove();
            } else {
              if (obj.data === "Already Registered") {
                Notiflix.Loading.remove();
                toast.error(CandidateAlreadyRegitered, {
                  autoClose: delay,
                  toastId: 1,
                });
              } else {
                Notiflix.Loading.remove();
                toast.error(SomethingWrong, {
                  autoClose: delay,
                  toastId: 1,
                });
              }
            }
          })
          .catch((err) => {
            Notiflix.Loading.remove();
            toast.error(err.message, {
              autoClose: delay,
              toastId: 1,
            });
          })
      );

    }
  };

  const GenerateOTP = (email) => {
    // Notiflix.Loading.standard();
    PostApiCall.postRequest(
      {
        name: email,
        updatedat: moment().format("MMM DD, YYYY h:mm A"),
      },
      "GenerateOTP"
    )
      .then((result) => {
        // Handle the response from the verification API
        if (!result.ok) {
          throw new Error("Failed to fetch data");
        }

        Notiflix.Loading.remove();

        toast.success("OTP has been sent to your email", {
          autoClose: delay,
        });

      })
      .catch((error) => {
        Notiflix.Loading.remove();

        console.error("Error verifying email:", error);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    // if (!user.RegisterType) {
    //   newErrors.RegisterType = "User type is required";
    // }
    if (!user.Name) {
      newErrors.Name = "Name is required";
    }

    if (!user.Email === "") {
      newErrors.Email = "Email address is required";
    } else {
      if (!EmailRegex.test(String(user.Email).toLowerCase())) {
        newErrors.Email = "Invalid email address";
      }
    }

    if (!user.Mobile) {
      newErrors.Mobile = "Contact is required";
    } else {
      if (!NumRegex.test(user.Mobile)) {
        newErrors.Mobile = "Invalid contact number";
      }
    }
    if (!user.Pass) {
      newErrors.Pass = "Password is required";
    }

    if (user.Pass !== user.Confirm_Pass) {
      newErrors.Confirm_Pass = "Passwords do not match";
    }
    if (!user.isAccept) {
      newErrors.isAccept = "Accept the terms and conditions to proceed";
    }
    if (!user.Source) {
      newErrors.Source = "Please select an option";
    }

    if (user.Source === "Other" && !user.OtherSource.trim()) {
      newErrors.Source = "Please specify source";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const AuthSubmit = async () => {
    try {
      Notiflix.Loading.standard();

      const payload = {
        name: user?.Name?.toLowerCase(),
        email: user?.Email?.toLowerCase(),
        password: user.Pass,
        mobile: user?.Mobile,
        usertype: "Seeker",
        updatedon: moment().format("ll"),
        addedon: moment().format("ll"),
        emailverify: "Yes",
        refercode: refercode || "",
        flag: false,
      };

      // Make the API request
      const resultdes = await PostApiCall.postRequest(
        payload,
        "RegisterCandidate"
      );
      const obj = await resultdes.json();

      if (resultdes.status === 200 || resultdes.status === 201) {
        const payload = {
          email: user?.Email?.toLowerCase(),
          password: user.Pass,
          isauth: true,
        };
        const method = "POST";
        const url = "CheckIfJobUserExists";

        // Dispatch the fetchData action
        // const userExist = await dispatch(fetchData(payload, method, url));

        // if (userExist) {
        //   history("/account");
        // }
      } else if (obj.data === "Already Registered") {
        Notiflix.Loading.remove();
        toast.error(CandidateAlreadyRegitered, {
          autoClose: delay,
          toastId: 1,
        });
      } else {
        Notiflix.Loading.remove();
        toast.error(obj.data || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    } catch (err) {
      Notiflix.Loading.remove();
      toast.error(err.message || SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    } finally {
      setPassModal(false);
      Notiflix.Loading.remove();
    }
  };

  const GoogleIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="20px"
      height="20px"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.67 0 6.97 1.41 9.42 3.69L39.66 6.5C35.5 2.85 30.02 0 24 0 14.87 0 7.1 5.29 3.56 12.93l8.4 6.6C13.61 13.59 18.48 9.5 24 9.5z"
      />
      <path
        fill="#34A853"
        d="M46.13 24.5c0-1.5-.13-2.95-.37-4.34H24v8.19h12.45c-.53 2.76-2.13 5.1-4.58 6.65v5.38h7.41c4.33-4 6.85-9.93 6.85-15.88z"
      />
      <path
        fill="#4A90E2"
        d="M11.96 28.45c-.57-1.32-.9-2.74-.9-4.26s.33-2.94.91-4.26l-8.41-6.6C1.2 16.77 0 20.25 0 24s1.2 7.23 3.56 10.41l8.4-6.6z"
      />
      <path
        fill="#FBBC05"
        d="M24 48c6.02 0 11.5-2.05 15.31-5.56l-7.4-5.38c-2.11 1.41-4.79 2.24-7.91 2.24-5.52 0-10.38-4.09-12.04-9.51l-8.4 6.6C7.1 42.72 14.87 48 24 48z"
      />
      <path fill="none" d="M0 0h48v48H0z" />
    </svg>
  );

  const onVerifyOTPClicked = async () => {
    if (OtpEntered.length < 6) {
      setShowError(true);
    } else {
      setShowError(false);
      try {
        const resultdes = await PostApiCall.postRequest(
          {
            name: user.Email,
            otp: OtpEntered,
          },
          "VerifyCandidateEmail"
        );

        const obj = await resultdes.json();

        if (resultdes.status === 200 || resultdes.status === 201) {
          setShowOTP(true);
          Report.success("Register Successfully", "", "okk");
        } else {
          toast.error(obj.data, {
            autoClose: delay,
            toastId: 1,
          });
        }
      } catch (err) {
        toast.error(err.toString(), {
          autoClose: delay,
          toastId: 1,
        });
      }
    }
  };

  return (
    <div >
      <ToastContainer />
      <Row className="d-flex justify-content-center shadow bg-white ">
        {showOTP ? (
          <Col lg={12} sm={12} md={12}>
            <div className="page-login-form px-2 py-3">
              <h3 className="text-center">
                <img className="w-25" src={logo} alt="verify mail" />
                <p
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textTransform: "initial",
                  }}
                >
                  Please check your email
                </p>

                <p
                  className="text-center"
                  style={{ fontSize: "13px", textTransform: "initial" }}
                >
                  {user.Email && (
                    <span>
                      We have sent a code to <br />
                      <b>{user.Email}</b>
                    </span>
                  )}
                </p>
              </h3>
              <form className="login-form" onSubmit={(e) => e.preventDefault()}>
                <div className="form-group otp-login">
                  <OtpInput
                    value={OtpEntered}
                    onChange={(e) => setOtpEntered(e)}
                    numInputs={6}
                    isInputNum={true}
                    separator={<span>&nbsp;&nbsp;&nbsp;</span>}
                  />
                </div>
                {showError && (
                  <div className="text-center text-danger">Invalid Input</div>
                )}
                <div className="text-center">
                  <button
                    className="btn btn-common log-btn mb-0"
                    style={{ borderRadius: 10 }}
                    onClick={onVerifyOTPClicked}
                  >
                    Verify OTP
                  </button>
                </div>
              </form>
              <ul className="form-links">
                <li className="text-center"></li>
              </ul>
            </div>
          </Col>
        ) : (
          <Col>
            <div className="page-login-form px-2 py-4">
              <h3>Create Your account</h3>

              <form
                className="login-form"
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className="form-group mb-0">
                  <div className="input-icon">
                    <i style={{ zIndex: 10 }}>
                      <User size={15} />
                    </i>
                    <input
                      type="text"
                      value={user.Name}
                      onChange={(e) => {
                        setUser({ ...user, Name: e.target.value });
                        setErrors((prev) => ({
                          ...prev,
                          Name: "",
                        }));
                      }}
                      style={{ textTransform: "capitalize" }}
                      className="form-control"
                      placeholder="Name"
                    />
                  </div>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Name}
                  </p>
                </div>
                <div className="form-group my-2">
                  <div className="input-icon">
                    <i style={{ zIndex: 10 }}>
                      <Mail size={15} />
                    </i>
                    <input
                      type="email"
                      value={user.Email.toLowerCase()}
                      onChange={(e) => {
                        setUser({ ...user, Email: e.target.value });
                        setErrors((prev) => ({
                          ...prev,
                          Email: "",
                        }));
                      }}
                      className="form-control"
                      placeholder="Email Address"

                    // style={{ textTransform: "lowercase" }}
                    />
                  </div>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Email}
                  </p>
                </div>

                <div className="form-group my-2">
                  <div className="input-icon">
                    <i style={{ zIndex: 10 }}>
                      <Smartphone size={15} />
                    </i>
                    <input
                      type="text"
                      value={user.Mobile}
                      maxLength={10}
                      onChange={(e) => {
                        setUser({ ...user, Mobile: e.target.value });
                        setErrors((prev) => ({
                          ...prev,
                          Mobile: "",
                        }));
                      }}
                      className="form-control"
                      placeholder="Enter Mobile No"

                    // style={{ textTransform: "lowercase" }}
                    />
                  </div>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Mobile}
                  </p>
                </div>
                <div className="form-group  my-2">
                  <div className="input-icon">
                    <i>
                      <Key size={15} />
                    </i>
                    <input
                      type={ShowPassword ? "text" : "password"}
                      value={user.Pass}
                      onChange={(e) => {
                        setUser({ ...user, Pass: e.target.value });
                        setErrors((prev) => ({
                          ...prev,
                          Pass: "",
                        }));
                        setShowConfirmPass(true);
                      }}
                      className="form-control"
                      placeholder="Create your Password"
                    />
                    {ShowPassword ? (
                      <Eye
                        size={15}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                        onClick={() => setShowPassword(!ShowPassword)}
                      />
                    ) : (
                      <EyeOff
                        size={15}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                        onClick={() => setShowPassword(!ShowPassword)}
                      />
                    )}
                  </div>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Pass}
                  </p>
                </div>
                {showConfirmPass && (
                  <div className="form-group mb-0">
                    <div className="input-icon">
                      <i>
                        <Key size={15} />
                      </i>
                      <input
                        type={showConfirmPassEye ? "text" : "password"}
                        value={user.Confirm_Pass}
                        onChange={(e) => {
                          setUser({ ...user, Confirm_Pass: e.target.value });
                          setErrors((prev) => ({
                            ...prev,
                            Confirm_Pass: "",
                          }));
                        }}
                        className="form-control"
                        placeholder="Confirm Password"
                      />
                      {showConfirmPassEye ? (
                        <Eye
                          size={15}
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            marginRight: "10px",
                            marginTop: "15px",
                          }}
                          onClick={() =>
                            setShowConfirmPassEye(!showConfirmPassEye)
                          }
                        />
                      ) : (
                        <EyeOff
                          size={15}
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            marginRight: "10px",
                            marginTop: "15px",
                          }}
                          onClick={() =>
                            setShowConfirmPassEye(!showConfirmPassEye)
                          }
                        />
                      )}
                    </div>
                    <p
                      style={{
                        width: "100%",

                        fontSize: "80%",
                        color: "#dc3545",
                      }}
                    >
                      {errors.Confirm_Pass}
                    </p>
                  </div>
                )}
                <div className="form-group my-2">
                  <div className="input-icon">
                    <i style={{ zIndex: 10 }}>
                      <Globe size={15} />
                    </i>
                    <select
                      value={user.Source}
                      onChange={(e) => {
                        setUser({
                          ...user,
                          Source: e.target.value,
                          OtherSource: e.target.value !== "Other" ? "" : user.OtherSource,
                        });

                        setErrors((prev) => ({
                          ...prev,
                          Source: "",
                        }));
                      }}
                      className="form-control"
                    >
                      <option value="" disabled>How did you know about BeteJobs?</option>
                      <option value="Instagram">Instagram</option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="Webinar">Webinar</option>
                      <option value="Referral">Referral</option>
                      <option value="GoogleSearch">Google Search</option>
                      <option value="BetelJobsWebsite">BetelJobs Website</option>
                      <option value="Other">Other (Please specify)</option>
                    </select>
                  </div>


                  <p
                    style={{
                      width: "100%",
                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.Source}
                  </p>
                </div>


                {user.Source === "Other" && (
                  <div className="form-group my-2">
                    <div className="input-icon">
                      <i style={{ zIndex: 10 }}>
                        <Mail size={15} />
                      </i>

                      <input
                        type="text"
                        value={user.OtherSource}
                        onChange={(e) => {
                          setUser({
                            ...user,
                            OtherSource: e.target.value,
                          });
                        }}
                        className="form-control"
                        placeholder="Please specify"
                      />
                    </div>
                  </div>
                )}

                <div className="form-group mt-3">
                  <FormGroup check inline>
                    <Input
                      type="checkbox"
                      value={user.isAccept}
                      onChange={(e) => {
                        setUser({ ...user, isAccept: e.target.checked });
                        setErrors((prev) => ({
                          ...prev,
                          isAccept: false,
                        }));
                      }}
                    />
                    <Label check className="ml-2" style={{ fontSize: "11px" }}>
                      I agree with{" "}
                      <a
                        href="/terms-condition"
                        style={{ cursor: "pointer" }}
                        target="__blank"
                      >
                        {" "}
                        terms & conditions
                      </a>
                    </Label>
                  </FormGroup>
                  <p
                    style={{
                      width: "100%",

                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors.isAccept}
                  </p>
                </div>
              </form>
              <button
                className="btn btn-common log-btn mb-0"
                style={{ borderRadius: 10 }}
                onClick={onVerifyClicked}
              >
                Submit
              </button>
              {/* <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                }}
                className="my-2"
              > */}
              {/* <hr
                  style={{
                    flex: 1,
                    border: "none",
                    borderTop: "1px solid #ccc",
                    margin: "0 10px",
                  }}
                />
                <Label style={{ fontSize: "11px" }}>Or</Label>
                <hr
                  style={{
                    flex: 1,
                    border: "none",
                    borderTop: "1px solid #ccc",
                    margin: "0 10px",
                  }}
                />
              </p>

              <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
              
                <GoogleLogin
                  text="signup_with"
                  onSuccess={handleGoogleLoginSuccess}
                  onError={handleGoogleLoginFailure}
                  render={(renderProps) => (
                    <button
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                      style={{
                        display: "flex",
                        justifyContent: "center",

                        alignItems: "center",
                        padding: "10px 20px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        backgroundColor: "white",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                    >
                   
                      <GoogleIcon />

                   
                    </button>
                  )}
                />
              </GoogleOAuthProvider> */}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default BannerForm;
